import { Offer } from '../../modules/rate-quote/types';
import { LockData } from './state';

export const CloseLockModalActionType = 'LOCK_MODAL__CLOSE_ACTION' as const;
export const closeLockModal = () => ({ type: CloseLockModalActionType });
export type CloseLockModal = ReturnType<typeof closeLockModal>;

// Submit Lock

export const LockOfferActionType = 'LOCK__SUBMIT_REQUEST_ACTION' as const;
export const lockOfferRequest = (payload: {
  rateQuoteId: string;
  borrowerScenarioId: string;
  sourceId: string;
  offer: Offer;
  offerId: string;
  rgTitle: boolean | undefined;
  loanId: string;
  attorney?: string;
  notes: string;
  userInfo: { email: string; name: string } | null;
  float: boolean;
}) => ({
  type: LockOfferActionType,
  payload
});
export type LockOfferAction = ReturnType<typeof lockOfferRequest>;

export const LockOfferSuccessActionType = 'LOCK__SUBMIT_SUCCESS_ACTION' as const;
export const lockOfferSuccess = (payload: { success: boolean; pending: boolean }) => ({
  type: LockOfferSuccessActionType,
  payload
});
export type LockOfferSuccessAction = ReturnType<typeof lockOfferSuccess>;

export const LockOfferFailureActionType = 'LOCK__SUBMIT_FAILURE_ACTION' as const;
export const lockOfferFailure = (payload: string) => ({
  type: LockOfferFailureActionType,
  payload
});
export type LockOfferFailureAction = ReturnType<typeof lockOfferFailure>;

// Get Lock Data
export const GetLockActionType = 'LOCK__GET_REQUEST_ACTION' as const;
export const getLockRequest = (payload: { rateQuoteId: string; offer: Offer }) => ({
  type: GetLockActionType,
  payload
});
export type GetLockAction = ReturnType<typeof getLockRequest>;

export const CancelGetLockActionType = 'LOCK__CANCEL_GET_REQUEST_ACTION' as const;
export const cancelGetLockRequest = () => ({
  type: CancelGetLockActionType
});
export type CancelGetLockActionType = ReturnType<typeof cancelGetLockRequest>;

export const GetLockSuccessActionType = 'LOCK__GET_SUCCESS_ACTION' as const;
export const getLockSuccess = (payload: {
  offerId: string;
  loanId: string;
  pending: boolean;
  rgTitle: boolean | undefined;
  attorney?: string;
  notes: string;
  link: string;
  lockId: string;
  updatedHubspot?: boolean;
  float: boolean;
}) => ({
  type: GetLockSuccessActionType,
  payload
});
export type GetLockSuccessAction = ReturnType<typeof getLockSuccess>;

export const GetLockFailureActionType = 'LOCK__GET_FAILURE_ACTION' as const;
export const getLockFailure = (payload: string) => ({
  type: GetLockFailureActionType,
  payload
});
export type GetLockFailureAction = ReturnType<typeof getLockFailure>;

// Undo (delete) Lock
export const DeleteLockActionType = 'LOCK__DELETE_REQUEST_ACTION' as const;
export const deleteLockRequest = (payload: {
  rateQuoteId: string;
  offerId: string;
  lockId: string;
  sourceId: string;
}) => ({
  type: DeleteLockActionType,
  payload
});
export type DeleteLockAction = ReturnType<typeof deleteLockRequest>;

export const DeleteLockSuccessActionType = 'LOCK__DELETE_SUCCESS_ACTION' as const;
export const deleteLockSuccess = () => ({
  type: DeleteLockSuccessActionType
});
export type DeleteLockSuccessAction = ReturnType<typeof deleteLockSuccess>;

export const DeleteLockFailureActionType = 'LOCK__DELETE_FAILURE_ACTION' as const;
export const deleteLockFailure = (payload: string) => ({
  type: DeleteLockFailureActionType,
  payload
});
export type DeleteLockFailureAction = ReturnType<typeof deleteLockFailure>;

// Edit Lock
export const EditLockActionType = 'LOCK__EDIT_REQUEST_ACTION' as const;
export const editLockRequest = (payload: {
  rateQuoteId: string;
  borrowerScenarioId: string;
  sourceId: string;
  offerId: string;
  offer: Offer;
  rgTitle: boolean | undefined;
  loanId: string;
  attorney?: string;
  notes: string;
  lockId: string;
  userInfo: { email: string; name: string } | null;
  link: string;
  float: boolean;
}) => ({
  type: EditLockActionType,
  payload
});
export type EditLockAction = ReturnType<typeof editLockRequest>;

export const EditLockSuccessActionType = 'LOCK__EDIT_SUCCESS_ACTION' as const;
export const editLockSuccess = () => ({
  type: EditLockSuccessActionType
});

export type EditLockSuccessAction = ReturnType<typeof editLockSuccess>;

// Update Offer Lock Fields
export const UpdateLockModalFieldsActionType = 'LOCK_MODAL__UPDATE_FIELDS' as const;
export const updateLockModalFields = (payload: { id: string; value: string | boolean }) => ({
  type: UpdateLockModalFieldsActionType,
  payload
});
export type UpdateLockModalFieldsAction = ReturnType<typeof updateLockModalFields>;

// Seed Lock Modal
export const SeedLockModalActionType = 'LOCK_MODAL__SEED_DATA' as const;
export const seedLockModal = (payload: { modalLock: LockData; offer: Offer }) => ({
  type: SeedLockModalActionType,
  payload
});
export type SeedLockModalAction = ReturnType<typeof seedLockModal>;
